export enum QuestionType {
    Checkbox,
    Radio,
    Range,
    Text,
}
